//Lazy Load
//http://jquery.eisbehr.de/lazy/
$(function() {
	$('.lazy').Lazy({
		effect: 'fadeIn',		
        visibleOnly: true,
		threshold: 300,
        afterLoad: function(element) {
            $(element).removeClass("loader");
        }
	});
});

var sliderBreakpoint = 768;

$(".product-slider").slick({
	lazyLoad: 'ondemand',
	slidesToShow: 4,
	slidesToScroll: 1,
	prevArrow:'<div class="slider-nav slider-prev"><img src="/images/ui/prev.png" alt="Previous Product" /></div>',
    nextArrow:'<div class="slider-nav slider-next"><img src="/images/ui/next.png" alt="Next Product" /></div>',
    responsive: [{ 
        breakpoint: sliderBreakpoint,
        settings: {
            slidesToShow: 2
        } 
    }]
});